module.exports = __webpack_public_path__ + "static/media/Etsy.48c92401.png";